import { FC } from "react";

import { DsButton, DsIcon } from "../components/ui";
import { makePhoneCall } from "../utils/general";

type PhoneCallButtonProspType = {
  phoneNumber: string;
  title: string;
};

const PhoneCallButton: FC<PhoneCallButtonProspType> = ({
  phoneNumber,
  title,
}) => {
  return (
    <DsButton
      className="w-full"
      variant="white"
      onClick={() => makePhoneCall(phoneNumber)}>
      <DsIcon icon="Phone" className="mr-2" />
      {`${title}`}
    </DsButton>
  );
};

export { PhoneCallButton };
